import React from 'react';
import { Box, Typography, TypographyProps } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';

interface CustomIconTextProps {
  text: string;
  gap?: number | string;
  reverse?: boolean;
  typographyProps?: TypographyProps;
  muiIcon?: React.ReactNode;
  iconProps?: SvgIconProps;
  customIconSrc?: string;
  customIconHeight?: number | string;
  customIconWidth?: number | string;
}

const CustomIconText: React.FC<CustomIconTextProps> = ({
  text,
  gap = 1,
  reverse = false,
  typographyProps,
  muiIcon,
  iconProps,
  customIconSrc,
  customIconHeight = 16,
  customIconWidth = 16
}) => {
  return (
    <Box
      display="flex !important"
      alignItems="center"
      flexDirection={reverse ? 'row-reverse' : 'row'}
      gap={gap}
    >
      {customIconSrc ? (
        <img
          src={customIconSrc}
          alt="custom-icon"
          height={customIconHeight}
          width={customIconWidth}
          style={{ display: 'block' }}
        />
      ) : (
        muiIcon &&
        React.cloneElement(muiIcon as React.ReactElement, { ...iconProps })
      )}
      <Typography {...typographyProps}>{text}</Typography>
    </Box>
  );
};

export default CustomIconText;
